export function createUserActionInputType(action) {
    switch (action) {
        case 'click': {
            var loggableTargetName = 'OPEN_ITEM';
            return { click: { loggableTargetName: loggableTargetName } };
        }
        case 'neverShowAgain': {
            return { explicitFeedback: { feedbackType: 'NEVER_SHOW_AGAIN' } };
        }
        // default is View
        default: {
            return { view: {} };
        }
    }
}
//# sourceMappingURL=createUserActionInputType.js.map